import React__default, { useCallback } from 'react';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import { FONT_WEIGHTS } from '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import { getRemValue } from '../../methods/getRemValue.js';
import { getHeightByViewPort } from '../../methods/getSizeByViewPort.js';
import 'bowser';
import '../../_virtual/_tslib.js';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../constants/StateList.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../../constants/serviceTypeId.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';

const ToggleBtn = ({ id, value, text, isActive = false, onClick, width, classname }) => {
    const _onClick = useCallback((e) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(e.target.dataset["val"]);
    }, [onClick]);
    return (React__default.createElement("div", { id: id, style: {
            height: getHeightByViewPort(35),
            width: "94px",
            borderRadius: "18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid",
            borderColor: isActive ? "#3054D6" : "#E7EBEE",
            backgroundColor: isActive ? "#3054D60F" : "#F6F9FB80",
            color: isActive ? "#3054D6" : "rgba(10, 34, 57, 0.6)",
            cursor: "pointer",
            fontSize: getRemValue(12),
            fontWeight: FONT_WEIGHTS.medium,
            letterSpacing: getRemValue(-0.13),
            lineHeight: getHeightByViewPort(35)
        }, "data-val": value, onClick: _onClick, className: classname }, text));
};

export { ToggleBtn as default };
//# sourceMappingURL=ToggleBtn.js.map
